<template>
  <div class="mt-1">
    <div v-if="isSort">
      <WsSlickSort
        :sortList="C_value"
        @sortList="$_onUpdateSort($event)"
      >
        <template v-slot="{sortItem}">
          <LvInfoBox
            :class="{'mb-2': C_value.length > 1 && conditionIndex !== C_value.length - 1}"
          >
            <div class="d-flex align-center">
              <div class="flex-grow-1">
                <div class="d-flex align-center">
                  <WsInfoText value="當" class="mr-1"/>
                  <WsStateSelect
                    disabled
                    :value="sortItem.value_operator"
                    :items="fields.value_operator.items"
                    :placeholder="fields.value_operator.placeholder"
                    class="mt-0"
                  />
                </div>
                <div class="d-flex align-center">
                  <WsStateInput
                    disabled
                    type="number"
                    :value="sortItem.limit_lower"
                    :placeholder="fields.limit_lower.placeholder"
                    class="mr-1 mt-1"
                  />
                  <WsInfoText
                    v-if="sortItem.value_operator === 'in' || sortItem.value_operator === 'not_in'"
                    value="與"
                    class="mr-1"
                  />
                  <WsStateInput
                    v-if="sortItem.value_operator === 'in' || sortItem.value_operator === 'not_in'"
                    disabled
                    type="number"
                    :value="sortItem.limit_upper"
                    :placeholder="fields.limit_upper.placeholder"
                  />
                </div>
                <div class="d-flex align-center">
                  <WsInfoText value="符合" class="text-no-wrap mr-1"/>
                  <WsStateSelect
                    disabled
                    :value="sortItem.risk_level"
                    :items="fields.risk_level.items"
                    :placeholder="fields.risk_level.placeholder"
                    class="mt-1"
                  />
                </div>
              </div>
              <v-icon
                :size="28"
                class="icon-margin"
              >mdi-drag-vertical
              </v-icon>
            </div>
          </LvInfoBox>
        </template>
      </WsSlickSort>
    </div>
    <div v-else class="mb-2">
      <LvInfoBox
        v-for="(condition, conditionIndex) in C_value"
        :key="conditionIndex"
        :class="{'mb-2': C_value.length > 1 && conditionIndex !== C_value.length - 1}"
      >
        <div class="d-flex align-center">
          <WsInfoText value="當" class="mr-1"/>
          <WsState
            type="select"
            rules="required"
            :value="condition.value_operator"
            :items="fields.value_operator.items"
            :placeholder="fields.value_operator.placeholder"
            class="mt-0 flex-grow-1"
            @input="$_onInput('value_operator', $event, conditionIndex)"
          />
          <WsIconBtn
            v-if="C_value.length > 1"
            :size="40"
            class="ml-1"
            tooltip="刪除"
            bgColor="#ffffff"
            @click="$_onDelete(conditionIndex)"
          >mdi-delete</WsIconBtn>
        </div>
        <div class="d-flex align-center">
          <WsState
            type="number"
            rules="required"
            :value="condition.limit_lower"
            :placeholder="fields.limit_lower.placeholder"
            class="mr-1 mt-1 flex-grow-1"
            @input="$_onInput('limit_lower', $event, conditionIndex)"
          />
          <WsInfoText
            v-if="condition.value_operator === 'in' || condition.value_operator === 'not_in'"
            value="與"
            class="mr-1"
          />
          <WsState
            v-if="condition.value_operator === 'in' || condition.value_operator === 'not_in'"
            type="number"
            rules="required"
            :value="condition.limit_upper"
            :placeholder="fields.limit_upper.placeholder"
            class="mt-1 flex-grow-1"
            @input="$_onInput('limit_upper', $event, conditionIndex)"
          />
        </div>
        <div class="d-flex align-center">
          <WsInfoText value="符合" class="text-no-wrap mr-1"/>
          <WsStateSelect
            :value="condition.risk_level"
            :items="fields.risk_level.items"
            :placeholder="fields.risk_level.placeholder"
            class="mt-1"
            @input="$_onInput('risk_level', $event, conditionIndex)"
          />
        </div>
      </LvInfoBox>
    </div>
    <WsBtn
      v-if="isSort"
      color="deleteBtn white--text"
      class="mr-3"
      @click="$_onDoneSort()"
    >
      <v-icon left>mdi-check</v-icon> 確定
    </WsBtn>
    <div v-else class="d-flex">
      <WsBtn
        outlined
        class="mr-3"
        @click="$_onAdd()"
      >
        <v-icon left>mdi-plus-circle-outline</v-icon> 新增條件式
      </WsBtn>
      <WsBtn
        v-if="C_value.length > 1"
        outlined
        @click="$_onSort()"
      >
        <v-icon left>mdi-swap-vertical</v-icon> 調整排序
      </WsBtn>
    </div>
  </div>
</template>

<script>
import M_numericalComparisonConditionSetting from '@/models/numericalComparisonConditionSetting';

export default {
  props: {
    value: {
      type: Array,
    },
  },
  data() {
    return {
      list: [
        {
          value_operator: {
            id: '',
            value: '',
          },
          limit_lower: '',
          limit_upper: '',
          risk_level: null,
        },
      ],
      C_value: [],
      fields: M_numericalComparisonConditionSetting.fields,
      isSort: false,
    }
  },
  mounted() {
    this.C_value = this.$_initVal();
  },
  watch: {
    C_value: {
      handler() {
        this.$emit('input', this.C_value);
      },
      deep: true,
    }
  },
  methods: {
    $_onInput(fieldKey, $event, conditionIndex) {
      this.C_value[conditionIndex][fieldKey] = $event;
    },
    $_initVal() {
      if (!this.value || (this.value && !this.value.length)) {
        const resultVal = this.$_createEmptyCondition();
        return [resultVal];
      } else {
        return this.value.map(rawItem => {
          const resultVal = {};
          for (let fieldKey in this.fields) {
            if (rawItem && rawItem[fieldKey] != undefined) {
              resultVal[fieldKey] = rawItem[fieldKey];
            } else resultVal[fieldKey] = null;
          }
          return resultVal;
        });
      }
    },
    $_onDelete(conditionIndex) {
      this.C_value.splice(conditionIndex, 1);
    },
    $_onSort() {
      this.isSort = true;
    },
    $_onDoneSort() {
      this.isSort = false;
    },
    $_createEmptyCondition() {
      const resultVal = {};
      for (let fieldKey in this.fields) {
        resultVal[fieldKey] = null;
      }
      return resultVal;
    },
    $_onAdd() {
      const condition = this.$_createEmptyCondition();
      this.C_value.push(condition);
    },
    $_onUpdateSort($event) {
      this.C_value = $event;
    }
  },
}
</script>